import { get } from 'lodash';

export const getAppeals = state => get(state, ['appeals', 'appeals']);
export const getAppealClaimant = state => get(state, ['appeals', 'appealClaimant']);
export const getAppealRecommendation = state =>
  get(state, ['appeals', 'appealRecommendations', 'data' ]);
export const getAppealRecommendationState = state =>
  get(state, ['appeals', 'appealRecommendations', 'state' ]);
export const getAgentSelectedProperties = state =>
  get(state, ['appeals', 'agentSelectedProperties']);